import React from 'react';
import Product from '../Product';


function Jumpers () {
    return (
        <div>
            <div>
                <Product title="Jumpers" start={17} end={23} />
            </div>
        </div>
    )
}

export default Jumpers;

